import { render, staticRenderFns } from "./RegistrationLayout.vue?vue&type=template&id=ab53b7b4&scoped=true"
import script from "./RegistrationLayout.vue?vue&type=script&lang=js"
export * from "./RegistrationLayout.vue?vue&type=script&lang=js"
import style0 from "./RegistrationLayout.vue?vue&type=style&index=0&id=ab53b7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab53b7b4",
  null
  
)

export default component.exports